import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogWrapper from 'cityads-v3/components/Dialog/DialogWrapper';
import CloseIcon from '@material-ui/icons/Close';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Article from 'cityads-v3/components/Article/Article';
import { scrollElemTo } from 'cityads-v3/utils/htmlUtils';

import classes from './PopupArticle.scss';

@connect(
  state => ({
    isMobile: state.app.isMobile,
  })
)
export default class PopupArticle extends Component {
  static propTypes = {
    title: PropTypes.string,
    open: PropTypes.bool,
    onRequestClose: PropTypes.func,
    isMobile: PropTypes.bool,
  }

  scrollUp = (evt) => {
    evt.preventDefault();

    let dialogScrollContainer = evt.target;

    while (dialogScrollContainer && !(dialogScrollContainer.classList && dialogScrollContainer.classList.contains(classes.dialogScrollBody))) {
      dialogScrollContainer = dialogScrollContainer.parentElement;
    }

    if (dialogScrollContainer) {
      scrollElemTo(dialogScrollContainer, 0, 0);
    }
  }

  render() {
    const { open, onRequestClose, title, article, children, closeLink, isMobile } = this.props;

    const content = article ?
      React.cloneElement(article, { inPopup: true }) :
      (
        <Article
          title={title}
          inPopup={true}
        >
          {children}
        </Article>
      );

    return (
      <div className={classes.dialogContainer}>
        <div className={classes.dialogHiddenContentBackup}>
          {open && !window ? content : null}
        </div>

        <DialogWrapper
          open           = {open}
          onClose        = {onRequestClose}
          scroll         = {isMobile ? 'paper' : 'body'}
          fullScreen     = {isMobile}
          classes        = {{
            root: classes.dialogRoot,
            paper: classes.paper,
            scrollBody: classes.dialogScrollBody,
          }}
        >
          {content}
          <DialogActions>
            <Button
              data-button-action = "close"
              className = {classes.dialogCloseButton}
              onClick   = {closeLink ? undefined : onRequestClose}
              component = {closeLink ? forwardRef((props, ref) => <Link {...props} to={closeLink} ref={ref} />) : undefined}
            >
              <CloseIcon />
            </Button>
            <Button
              className = {classes.dialogScrollupButton}
              onClick   = {this.scrollUp}
            >
              <KeyboardArrowUpIcon />
            </Button>
          </DialogActions>
        </DialogWrapper>
      </div>
    );
  }
}
